<template>

    <div :class="{'opacity-50 pointer-events-none': disabled}">
        <div class="flex flex-col items-start">
            <div class="flex justify-between w-full">
                <div>
                    <label class="text-sm" v-if="label" v-text="label"></label>
                    <span v-if="required" class="text-sn-dark-red ml-1">*</span>
                </div>
                <small v-if="extra" class="italic text-sn-grey" v-text="extra"></small>
            </div>
            <span v-if="description" class="text-xs opacity-60 ml-2" v-text="description"></span>
        </div>
        <div class="bg-sn-light-grey border relative w-full h-10 rounded-lg flex justify-between items-center"
             :class="{
                'border-sn-dark-red': errors,
                'border-sn-midlight-grey': !errors,
            }"
        >
            <div class="absolute left-3.5">
                <slot name="icon_left"></slot>
            </div>
            <div class="absolute right-3.5">
                <slot name="icon_right"></slot>
            </div>
            <div v-if="$slots.prefix" class="rounded-l-lg h-10 flex justify-center items-center border-r">
                <slot name="prefix">
                </slot>
            </div>
            <div v-if="prefix" class="rounded-l-lg px-3 h-10 flex justify-center items-center border-r">
                {{ prefix }}
            </div>
            <input
                class="w-full bg-transparent h-10 px-3 flex justify-start items-center"
                :min="min"
                :max="max"
                :class="{
                    'pl-10': $slots.icon_left,
                    'pr-10': $slots.icon_right,
                    'rounded-r-lg': $slots.prefix || prefix,
                    'rounded-lg': !$slots.prefix && !prefix,
                }"
                :required="required"
                :type="type"
                :placeholder="placeholder" v-model="model">
        </div>

        <small class="text-xs text-sn-dark-red" v-for="error in errors" v-text="error"></small>
    </div>

</template>

<style scoped>
    input::placeholder {
        @apply text-sn-grey
    }
</style>

<script setup lang="ts">

import Tooltip from "@/components/core/Tooltip.vue";

const props = defineProps({
    placeholder: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        required: false,
    },
    description: {
        type: String,
        required: false,
    },
    prefix: {
        type: String,
        required: false,
    },
    required: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        required: false,
        default: 'text',
    },
    min: {
        type: Number,
        required: false,
    },
    max: {
        type: Number,
        required: false,
    },
    errors: {
        type: Array as PropType<string[]>,
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    extra: {
        type: String,
        required: false,
    }
})

const model = defineModel({type: [String, Number]});

</script>